import React from 'react';
import EDCheckbox from '../../../../../../../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';

interface IProps {
  name: string;
  label: string;
}

class EkonomiskAnalysEditColumnCheckboxField extends React.Component<IProps> {
  render() {
    return (
      <Field name={this.props.name}>
        {({ value, onChange }) => (
          <EDCheckbox
            label={this.props.label}
            checked={value}
            onCheck={onChange}
          />
        )}
      </Field>
    );
  }
}

export default EkonomiskAnalysEditColumnCheckboxField;
